import React, { useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import {
  sizeIcon,
  archTypeIconHigh,
} from '../../assets';
import {
  Panel,
  RecommendationIcon,
  RecommendationLabel,
  RecommendationValue,
} from './SizePanelElements';
import { DarkSlateBlue } from '../../theme/colors';

const SubPanel = styled.div`
  display: flex;
  flex-flow: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

const LabelPanel = styled.div`
  display:flex;
`;

const Separator = styled.div`
  border-left: 1px solid ${DarkSlateBlue};
  height: 80px;
`;

type Props = {
  matching?: any,
};

const SizeArchPanel: React.FunctionComponent<Props> = (props) => {

  const { matching } = props;
  const { size, arch_type } = matching;
  const sizeNumber = size.value;
  const sizeDescription = size.description;

  return (
    <Panel>
      <SubPanel>
        <LabelPanel>
          <RecommendationIcon src={sizeIcon} />
          <RecommendationLabel className="arch-type-panel">
            <FormattedMessage id="drv.matching.size.label"></FormattedMessage>
          </RecommendationLabel>
        </LabelPanel>
        <RecommendationValue className="arch-type-panel">{sizeNumber} {sizeDescription}</RecommendationValue>
      </SubPanel>
      <Separator />
      <SubPanel>
        <LabelPanel>
          <RecommendationIcon src={archTypeIconHigh} />
          <RecommendationLabel className="arch-type-panel">
            <FormattedMessage id="drv.matching.arch-type.label"></FormattedMessage>
          </RecommendationLabel>
        </LabelPanel>
        <RecommendationValue className="arch-type-panel">{arch_type}</RecommendationValue>
      </SubPanel>
    </Panel>
  );
};

export default SizeArchPanel;
